export default {
  twoPeriodsPricesInYears: {
    id: 'checkout_services_bouygues_phoneline_setup_two_periods_prices_years',
    defaultMessage: `{firstPeriodPrice}/month for {years, plural,
      =0 {# years}
      =1 {# year}
      other {# years}
    }\n then {secondPeriodPrice}/month`,
  },
  twoPeriodsPricesInMonths: {
    id: 'checkout_services_bouygues_phoneline_setup_two_periods_prices_months',
    defaultMessage: `{firstPeriodPrice}/month for {months, plural,
      =0 {# months}
      =1 {# month}
      other {# months}
    }\n then {secondPeriodPrice}/month`,
  },
  onePeriodPrice: {
    id: 'checkout_services_bouygues_phoneline_setup_one_period_price',
    defaultMessage: '{price}/month',
  },
}
